<template>
  <div v-if="slaveClients != null && selectedSlaveClient != null" class="slave-clients">
    <vue-select id="slave-clients" key="slave-clients" :attributes="slaveClientsAttributes" @changed="changed"></vue-select>
  </div>    
</template>

<script>
    import notificator from '../../mixins/notificator';

    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'

    import VueSelect from '@/components/Fields/Select.vue';

    export default {
        components: {VueSelect},

        mixins: [notificator],

        data() {
            return {
                slaveClientsAttributes: {
                    classes: {value: 'form-control multiselect-blu'},
                    idField: {value: 'clientId'},
                    labelField: {value: 'clientName'},
                    options: {value: this.slaveClients},
                    required: {value: true},
                    value: {value: null}
                },
            }
        },

        created() {
            if(this.slaveClients == undefined || this.slaveClients == null) {
                this.slaveClientsAttributes['options']['value'] = [];
            } else {
                this.slaveClientsAttributes['options']['value'] = this.slaveClients;
            }
            
            if(this.slaveClients != undefined && this.slaveClients != null && this.selectedSlaveClient != null){
                this.slaveClientsAttributes['value']['value'] = this.selectedSlaveClient;
            }
        },

        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters([
                'slaveClients',
                'selectedSlaveClient'          
            ])
        },

        methods: {
            ...mapActions([
                'changeClientSlave'
            ]),

            // selectedSlaveClient() {
            //     this.slaveClientsAttributes['value']['value'] = this.selectedSlaveClient;
            // },

            changed(changed) {
                if(this.selectedSlaveClient != changed.value)
                    this.changeClientSlave(changed.value);
            }
        }
    }
</script>
